const demo_app = {
    notification: "Suggerimento: crea prima un account per testare l'esperienza di accesso.",
};
export default Object.freeze(demo_app);
